import * as cart from "@shopify/theme-cart";
import { removeTrapFocus } from "@shopify/theme-a11y";

const actions = ({ setState }) => ({
  getCart() {
    return cart.getState()
      .then(cart => ({ cart, items: cart.items, loading: false, item_count: cart.item_count }))
      .catch(error => ({ error, loading: false }));
  },
  removeItem(state, key) {
    cart.removeItem(key)
      .then(cart => setState({cart, items: cart.items, item_count: cart.item_count, loading: false}))
      .catch(error => ({ error, loading: false }));
  },
  updateItem(state, key, options) {
    cart.updateItem(key, options)
      .then(cart => setState({cart, items: cart.items, item_count: cart.item_count, loading: false}))
      .catch(error => ({ error, loading: false }));
  },
  closePopup() {
    removeTrapFocus()
    setState({popupActive: false})
  },
  openMinicart() {
    document.body.classList.add('mini-cart--active');
    setState({popupActive: true})
  },
  closeMinicart() {
    document.body.classList.remove('mini-cart--active');
    setState({popupActive: false})
  },
  toggleMinicart(state, e) {
    console.log('toggleMinicart' ,state.popupActive)
    e.preventDefault();
    document.body.classList.toggle('mini-cart--active');
    setState({popupActive: !state.popupActive})
  }
});

export default actions;

